import BasePresenter from "../../redare/presenter/BasePresenter";
import * as WebWorkbenchHttp from "../http/WebWorkbenchHttp";

/**
 * Created by RdevPlugins.JsPresenterBuilderAction on 2021-11-23 10:13:03.
 */

export default class WebWorkbenchPresenter extends BasePresenter {

    /**
     * @param body: {pwd,account}
     * @returns Promise
     */
    login(body, success, fails) {

        if (this._onBeforeLogin) {
            let data = this._onBeforeLogin(body);
            if (!data || typeof data !== 'object') {
                return;
            }
            body = data.body;
        }

        WebWorkbenchHttp.login(body).then(
            result => {
                this.closeDoingIndicator();
                this.closeLoadingIndicator();
                this.closeLoadMoreIndicator();

                if (success) {
                    success(result);
                    return;
                }

                if (this._onBeforeLoginSuccess) {
                    result = this._onBeforeLoginSuccess(result, { body });
                }

                if (this.view && this.view._onLoginSuccess) {
                    this.view._onLoginSuccess(result, { body });
                }
            },
            error => {
                this.closeDoingIndicator();
                this.closeLoadingIndicator();
                this.closeLoadMoreIndicator();

                if (fails) {
                    if (!fails(error)) {
                        this.tipError(error);
                    }
                } else {
                    this.tipError(error);
                }
            }
        );
    }

    /**
     * @param body: {pwd,account}
     * @returns Promise
     */
    wxLogin(body, success, fails) {

        if (this._onBeforeLogin) {
            let data = this._onBeforeLogin(body);
            if (!data || typeof data !== 'object') {
                return;
            }
            body = data.body;
        }

        WebWorkbenchHttp.wxLogin(body).then(
            result => {
                this.closeDoingIndicator();
                this.closeLoadingIndicator();
                this.closeLoadMoreIndicator();

                if (success) {
                    success(result);
                    return;
                }

                if (this._onBeforeLoginSuccess) {
                    result = this._onBeforeLoginSuccess(result, { body });
                }

                if (this.view && this.view._onLoginSuccess) {
                    this.view._onLoginSuccess(result, { body });
                }
            },
            error => {
                // this.closeDoingIndicator();
                // this.closeLoadingIndicator();
                // this.closeLoadMoreIndicator();

                // if (fails) {
                //     if (!fails(error)) {
                //         this.tipError(error);
                //     }
                // } else {
                //     this.tipError(error);
                // }
            }
        );
    }

    /**
     * @param body: {pwd,account}
     * @returns Promise
     */
    wxBind(body, success, fails) {

        if (this._onBeforeLogin) {
            let data = this._onBeforeLogin(body);
            if (!data || typeof data !== 'object') {
                return;
            }
            body = data.body;
        }

        WebWorkbenchHttp.wxBind(body).then(
            result => {
                this.closeDoingIndicator();
                this.closeLoadingIndicator();
                this.closeLoadMoreIndicator();

                if (success) {
                    success(result);
                    return;
                }

                if (this._onBeforeLoginSuccess) {
                    result = this._onBeforeLoginSuccess(result, { body });
                }

                if (this.view && this.view._onLoginSuccess) {
                    this.view._onLoginSuccess(result, { body });
                }
            },
            error => {
                this.closeDoingIndicator();
                this.closeLoadingIndicator();
                this.closeLoadMoreIndicator();

                if (fails) {
                    if (!fails(error)) {
                        this.tipError(error);
                    }
                } else {
                    this.tipError(error);
                }
            }
        );
    }

    /**
     * @param body: {pwd,account}
     * @returns Promise
     */
    getImg(body, success, fails) {

        if (this._onBeforeLogin) {
            let data = this._onBeforeLogin(body);
            if (!data || typeof data !== 'object') {
                return;
            }
            body = data.body;
        }

        WebWorkbenchHttp.getImg(body).then(
            result => {
                this.closeDoingIndicator();
                this.closeLoadingIndicator();
                this.closeLoadMoreIndicator();

                if (success) {
                    success(result);
                    return;
                }

                if (this._onBeforeLoginSuccess) {
                    result = this._onBeforeLoginSuccess(result, { body });
                }

                if (this.view && this.view._onLoginSuccess) {
                    this.view._onLoginSuccess(result, { body });
                }
            },
            error => {
                this.closeDoingIndicator();
                this.closeLoadingIndicator();
                this.closeLoadMoreIndicator();

                if (success) {
                    success(error);
                    return;
                }
                if (fails) {
                    if (!fails(error)) {
                        this.tipError(error);
                    }
                } else {
                    this.tipError(error);
                }
            }
        );
    }


    /**
     * @param body: {}
     * @returns Promise
     */
    loginOut(body, success, fails) {

        if (this._onBeforeLoginOut) {
            let data = this._onBeforeLoginOut(body);
            if (!data || typeof data !== 'object') {
                return;
            }
            body = data.body;
        }

        WebWorkbenchHttp.loginOut(body).then(
            result => {
                this.closeDoingIndicator();
                this.closeLoadingIndicator();
                this.closeLoadMoreIndicator();

                if (success) {
                    success(result);
                    return;
                }

                if (this._onBeforeLoginOutSuccess) {
                    result = this._onBeforeLoginOutSuccess(result, { body });
                }

                if (this.view && this.view._onLoginOutSuccess) {
                    this.view._onLoginOutSuccess(result, { body });
                }
            },
            error => {
                this.closeDoingIndicator();
                this.closeLoadingIndicator();
                this.closeLoadMoreIndicator();

                if (fails) {
                    if (!fails(error)) {
                        this.tipError(error);
                    }
                } else {
                    this.tipError(error);
                }
            }
        );
    }

    /**
     * @param body: {}
     * @returns Promise
     */
    getLoginUser(body, success, fails) {

        if (this._onBeforeGetLoginUser) {
            let data = this._onBeforeGetLoginUser(body);
            if (!data || typeof data !== 'object') {
                return;
            }
            body = data.body;
        }

        WebWorkbenchHttp.getLoginUser(body).then(
            result => {
                this.closeDoingIndicator();
                this.closeLoadingIndicator();
                this.closeLoadMoreIndicator();

                if (success) {
                    success(result);
                    return;
                }

                if (this._onBeforeGetLoginUserSuccess) {
                    result = this._onBeforeGetLoginUserSuccess(result, { body });
                }

                if (this.view && this.view._onGetLoginUserSuccess) {
                    this.view._onGetLoginUserSuccess(result, { body });
                }
            },
            error => {
                this.closeDoingIndicator();
                this.closeLoadingIndicator();
                this.closeLoadMoreIndicator();

                if (fails) {
                    if (!fails(error)) {
                        this.tipError(error);
                    }
                } else {
                    this.tipError(error);
                }
            }
        );
    }

    /**
     * @param body: {}
     * @returns Promise
     */
    getPhoneMobile(body, success, fails) {

        if (this._onBeforeGetLoginUser) {
            let data = this._onBeforeGetLoginUser(body);
            if (!data || typeof data !== 'object') {
                return;
            }
            body = data.body;
        }

        WebWorkbenchHttp.getPhoneMobile(body).then(
            result => {
                this.closeDoingIndicator();
                this.closeLoadingIndicator();
                this.closeLoadMoreIndicator();

                if (success) {
                    success(result);
                    return;
                }

                if (this._onBeforeGetLoginUserSuccess) {
                    result = this._onBeforeGetLoginUserSuccess(result, { body });
                }

                if (this.view && this.view._onGetLoginUserSuccess) {
                    this.view._onGetLoginUserSuccess(result, { body });
                }
            },
            error => {
                this.closeDoingIndicator();
                this.closeLoadingIndicator();
                this.closeLoadMoreIndicator();

                if (fails) {
                    if (!fails(error)) {
                        this.tipError(error);
                    }
                } else {
                    this.tipError(error);
                }
            }
        );
    }
    getPhoneMobile(body, success, fails) {

        if (this._onBeforeGetLoginUser) {
            let data = this._onBeforeGetLoginUser(body);
            if (!data || typeof data !== 'object') {
                return;
            }
            body = data.body;
        }

        WebWorkbenchHttp.getPhoneMobile(body).then(
            result => {
                this.closeDoingIndicator();
                this.closeLoadingIndicator();
                this.closeLoadMoreIndicator();

                if (success) {
                    success(result);
                    return;
                }

                if (this._onBeforeGetLoginUserSuccess) {
                    result = this._onBeforeGetLoginUserSuccess(result, { body });
                }

                if (this.view && this.view._onGetLoginUserSuccess) {
                    this.view._onGetLoginUserSuccess(result, { body });
                }
            },
            error => {
                this.closeDoingIndicator();
                this.closeLoadingIndicator();
                this.closeLoadMoreIndicator();

                if (fails) {
                    if (!fails(error)) {
                        this.tipError(error);
                    }
                } else {
                    this.tipError(error);
                }
            }
        );
    }

    forgetpwd(body, success, fails) {

        if (this._onBeforeGetLoginUser) {
            let data = this._onBeforeGetLoginUser(body);
            if (!data || typeof data !== 'object') {
                return;
            }
            body = data.body;
        }

        WebWorkbenchHttp.forgetpwd(body).then(
            result => {
                this.closeDoingIndicator();
                this.closeLoadingIndicator();
                this.closeLoadMoreIndicator();

                if (success) {
                    success(result);
                    return;
                }

                if (this._onBeforeGetLoginUserSuccess) {
                    result = this._onBeforeGetLoginUserSuccess(result, { body });
                }

                if (this.view && this.view._onGetLoginUserSuccess) {
                    this.view._onGetLoginUserSuccess(result, { body });
                }
            },
            error => {
                this.closeDoingIndicator();
                this.closeLoadingIndicator();
                this.closeLoadMoreIndicator();

                if (fails) {
                    if (!fails(error)) {
                        this.tipError(error);
                    }
                } else {
                    this.tipError(error);
                }
            }
        );
    }
}